export const addValue = (pfad, value) =>{
	return{
		type: 'ADD_VALUE',
		pfad: pfad,
		value: value,
	}
}

export const updateValue = (pfad, value) =>{
	return{
		type: 'UPDATE_VALUE',
		pfad: pfad,
		value: value,
	}
}

export const konfiguration = (pfad,wert=null) =>{
	return{
		type: 'KONFIGURATION',
		pfad: pfad,
		wert: wert,
	}
}

export const addFile = (lineage, name, extension, imgUid, statusCode) => {
	return {
	  type: 'ADD_FILE',
	  lineage:lineage,
	  name:name,
	  extension:extension,
	  fileUid:imgUid,
	  statusCode:statusCode,
	}
}

export const removeFile = (lineage, imgUid) => {
	return {
		type: 'REMOVE_FILE',
		lineage:lineage,
		fileUid:imgUid,
	}
}

export const updateFileStatus = (lineage, imgUid, statusCode) => {
	return {
	  type: 'UPDATE_FILE_STATUS',
	  lineage:lineage,
	  fileUid:imgUid,
	  statusCode:statusCode,
	}
}

export const hilfeAktivieren = (pfad) =>{
	return{
		type: 'HILFE_AKTIVIEREN',
		pfad: pfad,
	}
}

export const speziesSetzen = (obj, lineage) =>{
	return{
		type: 'SPEZIES_SETZEN',
		lineage: lineage,
		obj: obj,
	}
}


export const anzahlSpeziesSetzen = (value, lineage) =>{
	return{
		type: 'ANZAHL_SPEZIES_SETZEN',
		lineage: lineage,
		value: value,
	}
}

export const addCreature = (creature, path=null) =>{
	return{
		type: 'ADD_CREATURE',
		creature: creature,
		path: path,
	}
}

/**
 * @param {Array} path Kann array ([]) sein oder string (wert1.wert2.)
 */
export const addEntityToState = (path, entity) => {
	return {
		type: 'ADD_ENTITY_TO_STATE',
		path: path,
		entity: entity,
	}
}

/**
 * @param {Array} path Kann array ([]) sein oder string (wert1.wert2.)
 */
export const removeEntityFromState = (path) => {
	return {
		type: 'REMOVE_ENTITY_FROM_STATE',
		path: path,
	}
}